(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.contact-form__message').forEach((message) => message.focus());
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["faq-group"] && !Shopify.designMode) return;
  try {
    document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof HTMLElement)) return;

    const row = event.target.closest('details.faq-question');

    if (row) row.open = true;
  });
  } catch(e) { console.error(e); }
})();

})();
